/**
 * @generated SignedSource<<2070df92f5891f757455cd2161909827>>
 * @relayHash df27c7befb76213ac98c428ee1a8f581
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aa70fdfeacfcec58fca7255222d12f99bd3430ef17e4cd99ede5c9c4cede8e7a

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateSecurityLevelFieldInput = {
  id: string;
  operation: JiraSecurityLevelFieldOperationInput;
};
export type JiraSecurityLevelFieldOperationInput = {
  id?: string | null | undefined;
  operation: JiraSingleValueFieldOperations;
};
export type inlineEdit_securityLevelField_Mutation$variables = {
  input: JiraUpdateSecurityLevelFieldInput;
};
export type inlineEdit_securityLevelField_Mutation$data = {
  readonly jira: {
    readonly updateSecurityLevelField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly securityLevel: {
          readonly description: string | null | undefined;
          readonly id: string;
          readonly name: string | null | undefined;
          readonly securityId: string;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type inlineEdit_securityLevelField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateSecurityLevelField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly securityLevel: {
          readonly description: string | null | undefined;
          readonly id: string;
          readonly name: string | null | undefined;
          readonly securityId: string;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type inlineEdit_securityLevelField_Mutation = {
  rawResponse: inlineEdit_securityLevelField_Mutation$rawResponse;
  response: inlineEdit_securityLevelField_Mutation$data;
  variables: inlineEdit_securityLevelField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "concreteType": "JiraSecurityLevel",
  "kind": "LinkedField",
  "name": "securityLevel",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "securityId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "inlineEdit_securityLevelField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSecurityLevelFieldPayload",
            "kind": "LinkedField",
            "name": "updateSecurityLevelField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSecurityLevelField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "inlineEdit_securityLevelField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSecurityLevelFieldPayload",
            "kind": "LinkedField",
            "name": "updateSecurityLevelField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSecurityLevelField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "aa70fdfeacfcec58fca7255222d12f99bd3430ef17e4cd99ede5c9c4cede8e7a",
    "metadata": {},
    "name": "inlineEdit_securityLevelField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c7f6316658c7df13b137f916fadb6010";

export default node;
